export const Pagination = ({
  page = 1,
  totalPages = 0,
  onNext,
  onPrev,
  onPrevFirst,
  onNextLast,
}) => (
  <div className="d-flex align-items-center gap-2">
    <button
      className="save-btn"
      disabled={!!(page === 1)}
      onClick={onPrevFirst}
    >
      <img
        className="cursor"
        src="/assets/images/left.svg"
        alt="first_page"
        width={24}
        height={24}
      />
    </button>
    <button className="save-btn" disabled={!!(page === 1)} onClick={onPrev}>
      <img
        className="cursor"
        src="/assets/images/left_.svg"
        alt="prev_page"
        width={24}
        height={24}
      />
    </button>
    <div className="d-flex align-items-center gap-1 mw-30">
      <input
        readOnly
        type="number"
        value={page}
        className="book_shelf_draft_pagination_input mw-24 mh-25"
      />
      <span>/</span>
      <input
        readOnly
        type="number"
        value={totalPages}
        className="book_shelf_draft_pagination_input border-0 bg-transparent mw-24 mh-25"
      />
    </div>
    <button
      className="save-btn"
      disabled={!!(page === totalPages)}
      onClick={onNext}
    >
      <img
        src="/assets/images/right_.svg"
        alt="next_page"
        width={24}
        height={24}
      />
    </button>
    <button
      className="save-btn"
      disabled={!!(page === totalPages)}
      onClick={onNextLast}
    >
      <img
        src="/assets/images/right.svg"
        alt="last_page"
        width={24}
        height={24}
      />
    </button>
  </div>
);
